// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link, NavLink } from 'react-router-dom'

// Internal Dependencies:
import TimeShift from 'components/NowPlaying/TimeShift'
import NowPlayingButton from 'components/NowPlaying/NowPlayingButton'
import MyStation from 'components/MyStation/MyStation'

// Redux:
import { closeMenu, getMenuData } from 'actions/site'
import { getPageData } from 'actions/page'

const menuItems = siteData.site_menu
const menuClass = '-menu'

class Menu extends React.Component {
	constructor( props ) {
		super( props )
	}

	handleMenuItemClick = () => {
		this.props.handleCloseMenu()
	}

	handleMenuItemMouseOver = ( e ) => {
		let slug = e.currentTarget.getAttribute( 'data-id' )

		if ( slug ) {
			this.props.getPost( slug )
		}
	}

	handleFacebookClick = () => {
		// Fallback for when the app isn't installed:
		setTimeout( () => {
			window.location = 'https://www.facebook.com/faithfmaustralia/'
		}, 25 )

		window.location = 'fb://faithfmaustralia'
	}

	handleMobilePlayerButtonClick = () => {
		const { history, isPlaying } = this.props

		history.push( '/listen' )
	}

	renderLink( item ) {
		let linkMarkup,
			iconClass = item.icon_class ? item.icon_class : 'list'

		if ( '/' === item.url ) {
			linkMarkup = (
				<NavLink to='/' exact activeClassName="is-active" onClick={ this.handleMenuItemClick }>
					{ item.title }
				</NavLink>
			)
		} else if ( item.url.indexOf( '//' ) > -1 ) {
			linkMarkup = (
				<a href={ item.url } target="_blank" onClick={ this.handleMenuItemClick }>
					{ item.title }
				</a>
			)
		} else {
			linkMarkup = (
				<NavLink
					to={ item.url }
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-id={ item.url }
					dangerouslySetInnerHTML={ { __html: item.title } }
				/>
			)
		}

		return linkMarkup
	}

	render() {
		const { mobileMenu, menuIsOpen, isMobile } = this.props
		const wrapClass = menuIsOpen ? 'on-mobile-is-active primary-menu-wrap' : 'primary-menu-wrap'
		var menuItemsMarkup = ''

		if ( menuItems && Object.keys( menuItems ).length ) {
			menuItemsMarkup = Object.keys( menuItems )
				.map( ( key ) => {
					// Top level:

					let e = menuItems[ key ],
						childrenMarkup = '',
						linkMarkup = this.renderLink( e )

					if ( e.children && Object.keys( e.children ).length ) {
						// Children:

						let childrenItemsMarkup = Object.keys( e.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( e.children[ key ] )

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							})

						childrenMarkup = (
							<div className="-dropdown">
								<ul>
									{ childrenItemsMarkup }
								</ul>
							</div>
						)
					}

					return (
						<li key={ key }>
							{ linkMarkup }
							{ childrenMarkup }
						</li>
					)
				})
		}

		return (
			<div className={ wrapClass }>
				<div className="primary-menu">
					<ul className={ menuClass }>
						{ menuItemsMarkup }

						{ mobileMenu &&
							<li className="-social">
								<span className="-facebook" onClick={ this.handleFacebookClick }>
									<i className="icon-facebook-official" aria-hidden="true"></i>
								</span>

								<a className="-youtube" href="https://www.youtube.com/faithfmaustralia" target="_blank" rel="noopener">
									<i className="icon-youtube-square" aria-hidden="true"></i>
								</a>

								<a className="-instagram" href="https://www.instagram.com/faithfmaustralia" target="_blank" rel="noopener">
									<i className="icon-instagram" aria-hidden="true"></i>
								</a>

								<a className="-twitter" href="https://twitter.com/faithfmlive" target="_blank" rel="noopener">
									<i className="icon-twitter-square" aria-hidden="true"></i>
								</a>
							</li>
						}
					</ul>

					{ ! mobileMenu &&
						<TimeShift />
					}

					{ ! mobileMenu &&
						<MyStation />
					}

					{ isMobile && ! mobileMenu &&
						<div className="mobile-player-button" onClick={ this.handleMobilePlayerButtonClick }>
							<NowPlayingButton />
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen,
		isMobile: state.site.isMobile,
		page: state.page.selected,
		isPlaying: state.schedule.isPlaying
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleCloseMenu() {
			dispatch( closeMenu() )
		},

		getPost: ( slug ) => {
			dispatch( getPageData( slug, 'page', false, true ) )
		}
	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps, null, { pure: false } )( Menu )
)
